import { RichText, useBlockProps } from '@wordpress/block-editor';
import classnames from 'classnames';

export default function save( { attributes } ) {
	const {
		id,
		name,
		label,
		hideLabel,
		options,
		required,
		requiredText,
		showHelp,
		help,
		multiple,
		hidden,
	} = attributes;

	const blockProps = useBlockProps.save( {
		className: 'formello',
	} );

	const selectedOpts = options
		.filter( ( x ) => true === x.selected )
		.map( ( x ) => x.value );

	return (
		<div { ...blockProps }>
			<label htmlFor={ id } hidden={ hidden }>
				<RichText.Content tagName="span" value={ label } />
				{ required && (
					<span className="required">{ requiredText }</span>
				) }
			</label>
			<select
				defaultValue={ selectedOpts }
				name={ name || label }
				id={ id }
				multiple={ multiple }
				required={ required }
			>
				{ options.map( ( opt, index ) => {
					return (
						<option
							value={ opt.value || opt.label }
							key={ index }
							selected={ opt.selected }
						>
							{ opt.label }
						</option>
					);
				} ) }
			</select>
			{ showHelp && <RichText.Content tagName="small" value={ help } /> }
		</div>
	);
}
